import { get } from "@insite/client-framework/Services/ApiService";
import { PromotionMessagesCollectionModel } from "@store/Types/ApiModels";

export function getPromotionMessages() {
    const url = "/api/v1/promotionMessages";

    return get<PromotionMessagesCollectionModel>(url);
}
